"use client";

import { addChapterToShares } from "@/actions/chapter";
import { ShareLinkDialog } from "@/components/dialog/share-link-dialog";
import { Button } from "@/components/ui/button";
import { PROJECT_URL } from "@/config/project-details";
import { TChapter, TChapterStats } from "@/types/types";
import { tryCatch } from "@/utils/validators";
import { Share } from "lucide-react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
type ChapterShareButtonProps = {
  chapter: TChapter;
  chapterStats: TChapterStats;
};
export default function ChapterShareButton({
  chapter,
  chapterStats
}: ChapterShareButtonProps) {
  const [_sharesCount, setSharesCount] = useState(chapterStats._count.chapterShares);
  const chapterUrl = `${PROJECT_URL}/course/${chapter.section.course.slug}/chapter/${chapter.slug}`;

  // clear state when going to next chapter
  useEffect(() => {
    setSharesCount(chapterStats._count.chapterShares);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function handleShare() {
    setSharesCount(prev => prev + 1);
    const {
      error
    } = await tryCatch(addChapterToShares(chapter.id));
    if (error) {
      setSharesCount(prev => prev - 1);
      toast.error(error.message);
      return;
    }
  }
  return <ShareLinkDialog title="Share chapter" description="Let others know about this course!" shareUrl={chapterUrl} onShareAction={handleShare}>
      <Button variant="outline" size="icon" className="rounded-full">
        <Share size={20} className="opacity-90" />
      </Button>
    </ShareLinkDialog>;
}